// 프론트 쪽에서 모든 에러를 포괄 함.
export const SERVICE_ERROR = {
  code: 40001,
  name: 'SERVICE_ERROR',
  korMessage: '서비스 중 알 수 없는 오류가 발생하였습니다.',
  engMessage: 'An unknown error occurred during service.',
};

// 인증
export const SESSION_ERROR = {
  code: 41002,
  name: 'SESSION_ERROR',
  korMessage: '로그아웃 되었습니다.',
  engMessage: 'Session has expired.',
};

// 요청 및 검색
export const FAILED_REQUEST_ERROR = {
  code: 42001,
  name: 'FAILED_REQUEST_ERROR',
  korMessage: '데이터 요청에 실패하였습니다.',
  engMessage: 'The data request has failed.',
};
export const NETWORK_ERROR = {
  code: 42002,
  name: 'NETWORK_ERROR',
  korMessage: '웹 클라이언트 서버가 정상적으로 동작하지 않습니다.',
  engMessage: 'Web client server is not operating normally.',
};

// 에셋이 존재하지 않음
export const NO_ASSET_ERROR = {
  code: 42004,
  name: 'NO_ASSET_ERROR',
  korMessage: '에셋이 존재하지 않습니다.',
  engMessage: 'The asset does not exist.',
};

// 다운로드
export const NO_TARGET_ERROR = {
  code: 42005,
  name: 'NO_TARGET_ERROR',
  korMessage: '다운로드 할 대상 또는 파일이 존재하지 않습니다.',
  engMessage: 'The target or file to download does not exist.',
};

// 부분인출
export const NO_PARTIAL_WITHDRAWAL_NAME_ERROR = {
  code: 43001,
  name: 'NO_PARTIAL_WITHDRAWAL_NAME_ERROR',
  korMessage: '부분인출 명을 입력해 주세요.',
  engMessage: 'Please enter the partial withdrawal name.',
};
export const LIBRARY_ALREADY_EXISTS_ERROR = {
  code: 43002,
  name: 'LIBRARY_ALREADY_EXISTS_ERROR',
  korMessage: '이미 존재하는 부분인출 요청입니다.',
  engMessage: 'This is a partial withdrawal request that already exists.',
};
export const START_POINT_OVER_ERROR = {
  code: 43003,
  name: 'START_POINT_OVER_ERROR',
  korMessage: '시작점은 끝점 보다 크게 설정할 수 없습니다. ',
  engMessage: 'The starting point cannot exceed the ending point.',
};
export const END_POINT_OVER_ERROR = {
  code: 43004,
  name: 'END_POINT_OVER_ERROR',
  korMessage: '끝점은 시작점 보다 크게 설정할 수 없습니다. ',
  engMessage: 'The ending point cannot exceed the starting point.',
};
export const PARTIAL_FULL_REQUEST_ERROR = {
  code: 49601,
  name: 'PARTIAL_FULL_REQUEST_ERROR',
  korMessage: '부분인출 최대 요청 수를 초과하였습니다.',
  engMessage: 'The maximum count of requests has been exceeded.',
};

// 특수문자
export const SPECIAL_CHARACTER_ERROR = {
  code: 44001,
  name: 'SPECIAL_CHARACTER_ERROR',
  korMessage: '검색어에 사용할 수 없는 특수문자( / \\ = & % , ? ; )가 포함되어 있습니다.',
  engMessage: 'The search term contains special characters. ( / \\ = & % , ? ; )',
};

export const NOT_READY_TO_VIDEO_ERROR = {
  code: 45001,
  name: 'NOT_READY_TO_VIDEO_ERROR',
  korMessage: '비디오가 준비되지 않았습니다.',
  engMessage: 'The video is not ready.',
};

// video player Error
export const MEDIA = {
  ABORTED_ERROR: {
    code: 1,
    name: 'MEDIA_ERR_ABORTED',
    engMessage: "The fetching of the associated resource was aborted by the user's request.",
    korMessage: '사용자의 요청으로 인해 관련 리소스 가져오기가 중단되었습니다.',
  },
  NETWORK_ERROR: {
    code: 2,
    name: 'MEDIA_ERR_NETWORK',
    engMessage:
      'Some kind of network error occurred which prevented the media from being successfully fetched, despite having previously been available.',
    korMessage:
      '이전에 사용 가능 했음에도 불구하고 미디어를 성공적으로 가져 오지 못하게하는 일종의 네트워크 오류가 발생했습니다.',
  },
  DECODE_ERROR: {
    code: 3,
    name: 'MEDIA_ERR_DECODE',
    engMessage:
      'Despite having previously been determined to be usable, an error occurred while trying to decode the media resource, resulting in an error.',
    korMessage:
      '이전에 사용 가능한 것으로 확인되었지만 미디어 리소스를 디코딩하는 동안 오류가 발생하여 오류가 발생했습니다.',
  },
  SRC_NOT_SUPPORTED_ERROR: {
    code: 4,
    name: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
    engMessage:
      'The associated resource or media provider object (such as a MediaStream) has been found to be unsuitable.',
    korMessage:
      '연관된 자원 또는 매체 제공자 오브젝트 (예 : MediaStream)가 적합하지 않은 것으로 발견되었습니다.',
  },
};
